/**************************************************
 * Nombre:       Home_Profesionales
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloApartados from "./SubComponentes/TituloApartados";
import Tarjeta_Profesional from "../../Tarjetas/Tarjeta_Profesional";
import Boton from "./SubComponentes/Boton";
import {useNavigate} from "react-router";

const Home_Profesionales = () => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3,}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <TituloApartados titulo={'Conoce a nuestros'} inicio={'NUESTROS PROFESIONALES'}
                                         negrita={'Profesionales Certificados'}
                        />
                    </Grid>

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                        sx={{mt: 8}}
                    >

                        {profesionales.map((item) => (
                            <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Profesional item={item}/>
                            </Grid>
                        ))}

                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 10}}>
                        <Boton click={() => navigate('/Profesional')} texto={'Ver Todos los Profesionales'}/>
                    </Grid>

                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Profesionales

const profesionales = [
    {
        nombre: 'Mauricio Nicolás Battafarano',
        profesion: 'Medico Universidad de Buenos Aires',
        hora: 0,
        disponible: false,
        servicios: []
    }
]